import { PURGE, REHYDRATE } from 'redux-persist';
import {
  WAS_IN,
  LOCAL_PURGE,
  SET_UTM_INFO,
  SET_SUDO_USER,
  SET_REFERRAL_CODE,
} from '../actions/types';

const initialState = {
  wasInFinance: false,
  wasInLogin: false,
  utmInfo: { utmCampaign: null, utmMedium: null, utmSource: null },
  referralCode: null,
  isSudoUser: false,
};

const wasIn = (state, payload) => {
  return {
    ...state,
    ...payload,
  };
};

const setUtmInfo = (state, payload) => {
  return {
    ...state,
    utmInfo: payload.utmInfo,
  };
};

const setReferralCode = (state, payload) => {
  return {
    ...state,
    referralCode: payload.referralCode,
  };
};

const setSudoUser = (state, payload) => {
  return {
    ...state,
    isSudoUser: payload.isSudoUser,
  };
};

const rehydrate = payload => {
  return {
    ...initialState,
    isSudoUser: payload?.uiState?.isSudoUser || false,
  };
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case WAS_IN:
      return wasIn(state, payload);
    case SET_UTM_INFO:
      return setUtmInfo(state, payload);
    case SET_REFERRAL_CODE:
      return setReferralCode(state, payload);
    case SET_SUDO_USER:
      return setSudoUser(state, payload);
    case REHYDRATE:
      return rehydrate(payload);
    case PURGE:
      return initialState;
    case LOCAL_PURGE:
      return initialState;
    default:
      return state;
  }
};
